import React, {Component} from 'react';
import {gpn} from "../GPN"
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";
import logo from "../assets/images/logo.png";
import Modal from "../sections/MUI/Modal";

class Login extends Component {
    state = {
        step: 1,
        phone: "",
        code: "",
        interval: 120,

        loading: false,

        terms: "",
        modalTerms: false
    };

    componentDidMount() {
        this.props.setTitle("ورود | ثبت نام");

        let token = config.token;
        if (token !== "") {
            document.location.href = "/";
        }
        this.getTerms();
    }

    getTerms() {
        req.getRequest(`${config.api}/user/terms`)
            .then(r => {
                this.setState({
                    terms: r.terms
                });
            })
            .catch(err => {
            });
    }

    sendCode() {
        let {phone} = this.state;
        phone = phone ? phone.toString().trim() : "";

        if (phone.length === 11) {
            this.setState({
                loading: true
            });
            req.postRequest(`${config.api}/user/login/code`, {
                phone
            })
                .then(r => {
                    toast.info("کد تایید برای شما ارسال شد.");

                    this.setState({
                        step: 2,
                        interval: 120,
                        loading: false
                    });


                    let interval = 120;

                    let iv = setInterval(() => {
                        if (interval <= 0) {
                            clearInterval(iv);
                        } else {
                            interval = interval - 1;
                            this.setState({interval: interval - 1});
                        }
                    }, 1000);
                })
                .catch(err => {
                    config.handleError(err);
                    this.setState({
                        loading: false
                    });
                });

        } else {
            toast.error("شماره موبایل وارد شده صحیح نیست!")
        }
    }

    verify() {
        let {phone, code} = this.state;
        phone = phone.toString().trim();
        code = code ? code.toString().trim() : "";

        if (code !== "") {
            this.setState({
                loading: true
            });
            req.putRequest(`${config.api}/user/login/verify`, {
                phone, code
            })
                .then(r => {
                    toast.success("خوش آمدید!");
                    const {token} = r;
                    localStorage.setItem("token", token.toString());
                    document.location.href = "/";
                })
                .catch(err => {
                    config.handleError(err);
                    this.setState({loading: false});
                });
        } else {
            toast.error("کد تایید را وارد کنید!");
        }
    }

    render() {
        const {
            step, phone, code, interval, loading,
            terms = "", modalTerms = false
        } = this.state;

        return (
            <div className="login">
                <ModalLoading loading={loading}/>
                <Modal title="قوانین و مقررات"
                       display={modalTerms}
                       onCloseClick={() => this.setState({modalTerms: false})}
                       icon="terms">
                    <pre>{terms}</pre>
                </Modal>

                <div className="head">
                    <div className="logo">
                        <img src={logo} alt="قسطی‌تک" draggable={false}/>
                    </div>
                    <h1>ورود به <span>قسطی‌تک</span></h1>
                </div>
                {
                    step === 1 ?
                        <>
                            <Field name="phone"
                                   value={phone}
                                   type="number"
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   label="شماره موبایل"
                                   focus={true}
                                   maxLength={11}/>

                            <Button submit={false}
                                    icon="user-check"
                                    onClick={() => this.sendCode()}>ارسال کد تأیید</Button>
                        </>
                        :
                        <>
                            <p className="correct">
                                <span onClick={() => this.setState({
                                    step: 1,
                                    phone: "",
                                    code: "",
                                    interval: 120
                                })}>شماره&nbsp;{phone}&nbsp;وارد شده صحیح نیست؟</span>
                            </p>
                            <Field name="code"
                                   value={code}
                                   type="number"
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   label="کد تایید"
                                   focus={true}
                                   maxLength={7}/>

                            {
                                interval > 0 ?
                                    <>
                                        <p className="interval">
                                            <span>{interval}&nbsp;ثانیه&nbsp;تا ارسال مجدد کد تایید</span>
                                        </p>
                                    </>

                                    :
                                    <p className="resend-code">
                                        <span onClick={() => this.sendCode()}>ارسال مجدد کد تایید</span>
                                    </p>
                            }
                            <Button submit={false}
                                    icon="check" onClick={() => this.verify()}>ورود | ثبت نام</Button>

                        </>
                }
                <div className="accept-terms">
                    ورود یا ثبت نام شما در قسطی تک به منزله پذیرش کامل <strong
                    onClick={() => this.setState({modalTerms: true})}>قوانین و مقررات</strong> می باشد.
                </div>
            </div>
        );
    }
}

export default gpn(Login);